export default function SolutionSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            資料を渡して、報告するだけ。<br />AIがプロジェクトを整理します。
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed">
            ”おもいむすび”は、プロジェクト計画の作成、タスク管理、ガントチャート、日報、ファイル管理、チームコミュニケーションを一元化するAIプロジェクト管理ツールです。
          </p>
        </div>
      </div>
    </section>
  );
}